import request from '../../../core/wrappers/axios-wrapper';
import { AutoReturnAndResendUrls } from '../../../types/constants/apiUrls/autoReturnAndResend/autoReturnAndResendUrls';
import { RequestType } from '../../../types/enums/request-enums';
import type {
    AutoReturnReportDetailRequest,
    AutoReturnReportDetailsResponse,
    AutoReturnReportsResponse,
} from '../../../pages/AutoReturnAndResend/autoReturnAndResend.types';

const GetAutoReturnReports = (): Promise<AutoReturnReportsResponse> =>
    request({
        url: AutoReturnAndResendUrls.reports,
        method: RequestType.GET,
    });

const GetAutoReturnReportDetails = (
    params: AutoReturnReportDetailRequest
): Promise<AutoReturnReportDetailsResponse> =>
    request({
        url: AutoReturnAndResendUrls.reportDetails,
        method: RequestType.POST,
        data: params,
    });

const AutoReturnAndResendQuery = {
    GetAutoReturnReports,
    GetAutoReturnReportDetails,
};

export default AutoReturnAndResendQuery;
